(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('RoleIbqDetailController', RoleIbqDetailController);

    RoleIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Role', 'Person'];

    function RoleIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Role, Person) {
        var vm = this;

        vm.role = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:roleUpdate', function(event, result) {
            vm.role = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
